export { default } from './svg/spacing-loose.svg';
